import { call, put, select, takeEvery } from "redux-saga/effects";
import * as ShoppingActions from "./shopping.actions";
import ShoppingAPI from "./shopping.api";
import SocialAPI from "../social/social.api";
import { ShoppingActionTypes } from "./shopping.model";
import Swal from "sweetalert2";
import moment from "moment";
import { uploadProductsSuccess } from "../file/file.actions";
import { getImage, getUserProfile } from "../user/user.selector";
import toastr from "toastr";

export function* handleFetchCategories(action) {
    try {
        const response = yield call(SocialAPI.GetCategories, action.payload);
        yield put(ShoppingActions.getCategorySuccess(response));
    } catch (e) {
        yield put(ShoppingActions.getCategoryFailure(e));
    }
}

export function* handleCreateProduct(action) {
    try {
        const response = yield call(ShoppingAPI.CreateProduct, action.payload);
        const response1 = yield call(ShoppingAPI.GetProductByIds, {
            products: [response.data._id],
        });
        response.data.images = getImage(
            response1.data.listProduct[0].attachments
        );
        yield put(ShoppingActions.addProductSuccess(response));
        const user = yield select(getUserProfile);
        yield put(ShoppingActions.getProductRequest(user._id));
        Swal.fire({
            title: "Success",
            text: "Product created successfully",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(ShoppingActions.addProductFailure(e));
    }
}

export function* handleUpdateProduct(action) {
    try {
        const response = yield call(ShoppingAPI.UpdateProduct, action.payload);
        const userProfile = yield select(getUserProfile);
        yield put(ShoppingActions.getProductRequest(userProfile._id));
        Swal.fire({
            title: "Success",
            text: "Product info is updated",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        yield put(
            uploadProductsSuccess({
                data: {},
            })
        );
    } catch (e) {
        yield put(ShoppingActions.updateProductFailure(e));
    }
}

export function* handleUpdateProductStatus(action) {
    try {
        const response = yield call(
            ShoppingAPI.UpdateProductStatus,
            action.payload
        );
        yield put(ShoppingActions.updateProductStatusSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.updateProductStatusFailure(e));
    }
}

export function* handleFetchCart(action) {
    try {
        const response = yield call(ShoppingAPI.GetCart, action.payload);
        yield put(ShoppingActions.getCartSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.getCartFailure(e));
    }
}

export function* handleFetchProductIDs(action) {
    try {
        const response = yield call(
            ShoppingAPI.GetProductByIds,
            action.payload
        );
        yield put(ShoppingActions.getProductByIDSSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.getProductByIDSFailure(e));
    }
}

export function* handleFetchProduct(action) {
    try {
        const response = yield call(ShoppingAPI.GetProducts, action.payload);
        yield put(ShoppingActions.getProductSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.getProductFailure(e));
    }
}

export function* handleFetchProducts(action) {
    try {
        const response = yield call(ShoppingAPI.GetProductses, action.payload);
        yield put(ShoppingActions.getProductsSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.getProductsFailure(e));
    }
}

export function* handleAddCart(action) {
    try {
        const history = action.payload.history;
        delete action.payload.history;
        delete action.payload.canNavigate;
        const response = yield call(ShoppingAPI.AddItemToCart, action.payload);
        yield put(ShoppingActions.addCartSuccess(response));
        toastr.success("Product added to cart", "Cart");
        // $(".added-to-cart").css("visibility", "visible");
        // setTimeout(() => {
        //     $(".added-to-cart").css("visibility", "hidden");
        // }, 2000);
        if (history) {
            history("/page/checkout", {
                state: {
                    checkout: true,
                    product: action.payload.product,
                },
            });
        }
        yield put(ShoppingActions.getCartRequest());
    } catch (e) {
        yield put(ShoppingActions.addCartFailure(e));
    }
}

export function* handleUpdateCart(action) {
    try {
        const response = yield call(ShoppingAPI.UpdateCart, action.payload);
        yield put(ShoppingActions.updateCartSuccess(response));
        yield put(ShoppingActions.getCartRequest());
    } catch (e) {
        yield put(ShoppingActions.updateCartFailure(e));
    }
}

export function* handleAddOrder(action) {
    try {
        const response = yield call(ShoppingAPI.CreateOrder, action.payload);
        yield put(ShoppingActions.addOrderSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.addOrderFailure(e));
    }
}

export function* handleUpdateOrder(action) {
    try {
        const response = yield call(ShoppingAPI.UpdateOrder, action.payload);
        yield put(ShoppingActions.updateOrderSuccess(response));
        Swal.fire({
            title: "Changes updated",
            text: "You will receive a notification of the new update",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        const response1 = yield call(
            ShoppingAPI.GetOrderById,
            action.payload.id
        );
        let selectedAddress = response1.data.deliveryAddress;
        let totalShippingFee = response1.data.shippingFee;
        let totalProductPrice =
            response1.data.totalPrices - response1.data.shippingFee;
        const carts = response1.data.orderItems.map((x) => {
            return ` <tr>
            <td align="center" style="padding:4px;">
                <img style="border:2px solid #CECECE;width:64px;height:64px;vertical-align: text-top"
                    src="${getImage(x.product.attachments)}" />
            </td>
            <td style="padding:4px;text-align: left; font-weight: 600;">
                ${x.productName}
            </td>
            <td style="padding:4px;text-align: center; font-weight: 600;">${
                x.quantity
            }</td>
            <td style="padding:4px;text-align: center; color:#0038FF; font-weight: 600">${
                x.product.currency
            } ${x.product.price.toFixed(2)}</td>
        </tr>`;
        });
        const mail = `        <p style="border: 5px solid #6f51ff"></p>
        <p style="text-align: left;
        font-weight: bold;
        font-size: 22px;
        color : #6f51ff;
        margin: 0;
        padding: 8px;">
            Hi ${response1.data.buyer.fullName},
        </p>
        <p style="text-align: left;
        line-height: 20px;
        margin: 0;
        font-size: 16px;
        padding: 8px;">
            Ready or not, here it comes!<br />
            Your Ulalive order <b>#${
                response1.data.code
            }</b> has shipped and is on its way!
        </p>
        <div style="background-color:#ffffff;  margin: 16px;padding : 16px;    max-width: 600px;
        margin: 0 auto;    border-radius: 12px;">
            <table width="100%" style="line-height:30px">
                <tr>
                    <td><b>Order #: 1234</b></td>
                    <td colspan="2" style="text-align:right;" align="right">
                        <b>You placed this order on ${moment(
                            response1.data.dateCreated
                        ).format("DD/MM/YYYY")}</b>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <p style="border-bottom: 1px solid #CECECE;"></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>Shipping Destination</span>
                        <br />
                        <b>
                        ${selectedAddress.name},<br/>
                        ${selectedAddress.address},<br/>
                        ${selectedAddress.subAddress},<br/>
                        ${selectedAddress.state} ${
            selectedAddress.postCode
        }<br/>
                        ${selectedAddress.phone}<br/>
                        </b>
                    </td>
                    <td colspan="2" style="text-align:left;vertical-align: top;" align="left">
                        Shipping Type<br />
                        <b>Standard Shipping via ${
                            response1.data.shippingInfo.courier
                        }</b><br />
                        <a href="https://parcelsapp.com/en/tracking/${
                            response1.data.shippingInfo.trackingNumber
                        }" style="color : #6f51ff;font-weight: 700;">Track Now</a>
                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <p style="border-bottom: 5px solid #CECECE;"></p>
                    </td>
                </tr>

                <tr>
                    <td colspan="3">
                        <table width="100%" border="1" style=" border: 1px solid #CECECE;
                        border-collapse: collapse;margin-top: 8px;margin-bottom:8px">
                            <tr>
                                <th style="text-align: left; color:#A1A1A1;padding:4px"></th>
                                <th style="text-align: left; color:#A1A1A1;padding:4px">ITEM</th>
                                <th style="text-align: center; color:#A1A1A1;padding:4px">QTY</th>
                                <th style="text-align: center; color:#A1A1A1;padding:4px">PRICE</th>
                            </tr>
                            ${carts.join("")}
                            <tr>
                                <td style="text-align: right; color:#000;padding:4px" colspan="3">Subtotal</td>
                                <td style="text-align: right; color:#000;padding:4px">${
                                    response1.data.orderItems[0].product
                                        .currency
                                } ${totalProductPrice.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td style="text-align: right; color:#000;padding:4px" colspan="3">Shipping</td>
                                <td style="text-align: right; color:#000;padding:4px">${
                                    response1.data.orderItems[0].product
                                        .currency
                                } ${totalShippingFee.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td style="text-align: right; color:#000;font-weight: 700;padding:4px;" colspan="3">Total</td>
                                <td style="text-align: right; color:#000; font-weight: 700;padding:4px;">${
                                    response1.data.orderItems[0].product
                                        .currency
                                } ${(
            totalProductPrice + totalShippingFee
        ).toFixed(2)}</td>
                            </tr>
                        </table>
                    </td>
                </tr>                
                <tr>
                    <td colspan="3">
                        <p> You can always check the status of your order by clicking on the My Account link at the top
                            of every
                            page.</p>
                        <p>
                            Thank you for shopping with <a style="text-decoration: none;color: #0038FF"
                                href="https://app.ulalive.com">Ulalive</a> , and we hope you will revisit us soon.
                        </p>
                    </td>
                </tr>
            </table>
        </div>
`;

        SocialAPI.sendEmailNotification({
            message: mail,
            subject: "Order Update From Ulalive",
            to: response1.data.buyer.email,
        });

        // SocialAPI.sendEmailNotification({
        //     message: mail,
        //     subject: "Order Update From Ulalive",
        //     to: response1.data.seller.email
        // });
        yield put(ShoppingActions.getOrderByIDSuccess(response1));
    } catch (e) {
        yield put(ShoppingActions.updateOrderFailure(e));
    }
}

export function* handleFetchOrder(action) {
    try {
        const response = yield call(ShoppingAPI.GetOrderList, action.payload);
        yield put(ShoppingActions.getOrderSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.getOrderFailure(e));
    }
}

export function* handleFetchOrderID(action) {
    try {
        const response = yield call(ShoppingAPI.GetOrderById, action.payload);
        yield put(ShoppingActions.getOrderByIDSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.getOrderByIDFailure(e));
    }
}

export function* handleCreateOrderGroup(action) {
    try {
        const response = yield call(
            ShoppingAPI.CreateOrderGroup,
            action.payload
        );
        yield put(ShoppingActions.createOrderGroupSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.createOrderGroupFailure(e));
    }
}

export function* handleFetchPlans(action) {
    try {
        const response = yield call(ShoppingAPI.GetPlanDetails, action.payload);
        yield put(ShoppingActions.fetchPlansSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.fetchPlansFailure(e));
    }
}

export function* handlePaymentConfig(action) {
    try {
        const response = yield call(
            ShoppingAPI.GetPaymentConfig,
            action.payload
        );
        yield put(ShoppingActions.fetchPaymentConfigSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.fetchPaymentConfigFailure(e));
    }
}

export function* handlePayoutConfig(action) {
    try {
        const response = yield call(
            ShoppingAPI.GetPaymentPayoutConfig,
            action.payload
        );
        yield put(ShoppingActions.fetchPaymentPayoutSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.fetchPaymentPayoutFailure(e));
    }
}

export function* handleCreateSubscription(action) {
    try {
        const response = yield call(
            ShoppingAPI.CreateSubscription,
            action.payload
        );
        yield put(ShoppingActions.createSubscriptionSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.createSubscriptionFailure(e));
    }
}

export function* handleFetchBankAccount(action) {
    try {
        const response = yield call(
            ShoppingAPI.GetBankAccounts,
            action.payload
        );
        yield put(ShoppingActions.getBankAccountSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.getBankAccountFailure(e));
    }
}

export function* handleCreateBankAccount(action) {
    try {
        const response = yield call(
            ShoppingAPI.CreateBankAccount,
            action.payload
        );
        yield put(ShoppingActions.addBankAccountSuccess(response));
        Swal.fire({
            title: "Success",
            text: "Your bank account has been saved",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });

        yield put(ShoppingActions.getBankAccountRequest());
    } catch (e) {
        yield put(ShoppingActions.addBankAccountFailure(e));
    }
}

export function* handleUpdateBankAccount(action) {
    try {
        const response = yield call(
            ShoppingAPI.UpdateBankAccount,
            action.payload
        );
        yield put(ShoppingActions.updateBankAccountSuccess(response));
        Swal.fire({
            title: "Bank details",
            text: "Your changes have been saved",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        yield put(ShoppingActions.getBankAccountRequest());
    } catch (e) {
        yield put(ShoppingActions.updateBankAccountFailure(e));
    }
}

export function* handleDeleteBankAccount(action) {
    try {
        const response = yield call(
            ShoppingAPI.DeleteBankAccount,
            action.payload
        );
        yield put(ShoppingActions.deleteBankAccountSuccess(response));
        yield put(ShoppingActions.getBankAccountRequest());
    } catch (e) {
        yield put(ShoppingActions.deleteBankAccountFailure(e));
    }
}

export function* handleDeleteProduct(action) {
    try {
        const response = yield call(
            ShoppingAPI.DeleteProductById,
            action.payload
        );
        yield put(ShoppingActions.deleteProductSuccess(response));
        yield put(ShoppingActions.getProductRequest());
    } catch (e) {
        yield put(ShoppingActions.deleteProductFailure(e));
    }
}

export function* handleFetchReview(action) {
    try {
        const response = yield call(
            ShoppingAPI.GetReviews,
            action.payload
        );
        yield put(ShoppingActions.getReviewSuccess(response));
    } catch (e) {
        yield put(ShoppingActions.getReviewFailure(e));
    }
}

export function* handleCreateReview(action) {
    try {
        const response = yield call(
            ShoppingAPI.CreateReview,
            action.payload
        );
        yield put(ShoppingActions.addReviewSuccess(response));
        Swal.fire({
            title: "Review",
            text: "Review Created Succesfully",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
 
    } catch (e) {
        yield put(ShoppingActions.addReviewFailure(e));
    }
}

export function* handleUpdateReview(action) {
    try {
        const response = yield call(
            ShoppingAPI.UpdateReview,
            action.payload
        );
        yield put(ShoppingActions.updateReviewSuccess(response));
        Swal.fire({
            title: "Review",
            text: "Review Updated Succesfully",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        yield put(ShoppingActions.getReviewRequest());
    } catch (e) {
        yield put(ShoppingActions.updateReviewFailure(e));
    }
}

export function* handleDeleteReview(action) {
    try {
        const response = yield call(
            ShoppingAPI.DeleteReview,
            action.payload
        );
        yield put(ShoppingActions.deleteReviewSuccess(response));
        yield put(ShoppingActions.getReviewRequest());
    } catch (e) {
        yield put(ShoppingActions.deleteReviewFailure(e));
    }
}

export function* ShoppingSaga() {
    yield takeEvery(
        ShoppingActionTypes.FETCH_CATEGORY_REQUEST,
        handleFetchCategories
    );
    yield takeEvery(
        ShoppingActionTypes.CREATE_PRODUCT_REQUEST,
        handleCreateProduct
    );
    yield takeEvery(
        ShoppingActionTypes.UPDATE_PRODUCT_REQUEST,
        handleUpdateProduct
    );
    yield takeEvery(
        ShoppingActionTypes.DELETE_PRODUCT_REQUEST,
        handleDeleteProduct
    );
    yield takeEvery(
        ShoppingActionTypes.UPDATE_PRODUCT_STATUS_REQUEST,
        handleUpdateProductStatus
    );
    yield takeEvery(
        ShoppingActionTypes.FETCH_PRODUCT_REQUEST,
        handleFetchProduct
    );
    yield takeEvery(
        ShoppingActionTypes.FETCH_PRODUCTS_REQUEST,
        handleFetchProducts
    );
    yield takeEvery(
        ShoppingActionTypes.FETCH_PRODUCT_IDS_REQUEST,
        handleFetchProductIDs
    );
    yield takeEvery(ShoppingActionTypes.FETCH_CART_REQUEST, handleFetchCart);
    yield takeEvery(ShoppingActionTypes.CREATE_CART_REQUEST, handleAddCart);
    yield takeEvery(ShoppingActionTypes.UPDATE_CART_REQUEST, handleUpdateCart);
    yield takeEvery(ShoppingActionTypes.CREATE_ORDER_REQUEST, handleAddOrder);
    yield takeEvery(
        ShoppingActionTypes.FETCH_ORDER_ID_REQUEST,
        handleFetchOrderID
    );
    yield takeEvery(
        ShoppingActionTypes.UPDATE_ORDER_REQUEST,
        handleUpdateOrder
    );
    yield takeEvery(ShoppingActionTypes.FETCH_ORDER_REQUEST, handleFetchOrder);
    yield takeEvery(
        ShoppingActionTypes.CREATE_ORDERGROUP_REQUEST,
        handleCreateOrderGroup
    );
    yield takeEvery(ShoppingActionTypes.FETCH_PLANS_REQUEST, handleFetchPlans);
    yield takeEvery(
        ShoppingActionTypes.FETCH_PAYMENT_CONFIG_REQUEST,
        handlePaymentConfig
    );
    yield takeEvery(
        ShoppingActionTypes.FETCH_PAYMENT_PAYOUT_REQUEST,
        handlePayoutConfig
    );
    yield takeEvery(
        ShoppingActionTypes.CREATE_SUBSCRIPTION_REQUEST,
        handleCreateSubscription
    );

    yield takeEvery(
        ShoppingActionTypes.FETCH_BANK_ACCOUNT_REQUEST,
        handleFetchBankAccount
    );
    yield takeEvery(
        ShoppingActionTypes.CREATE_BANK_ACCOUNT_REQUEST,
        handleCreateBankAccount
    );
    yield takeEvery(
        ShoppingActionTypes.UPDATE_BANK_ACCOUNT_REQUEST,
        handleUpdateBankAccount
    );
    yield takeEvery(
        ShoppingActionTypes.DELETE_BANK_ACCOUNT_REQUEST,
        handleDeleteBankAccount
    );

    yield takeEvery(
        ShoppingActionTypes.FETCH_REVIEW_REQUEST,
        handleFetchReview
    );
    yield takeEvery(
        ShoppingActionTypes.CREATE_REVIEW_REQUEST,
        handleCreateReview
    );
    yield takeEvery(
        ShoppingActionTypes.UPDATE_REVIEW_REQUEST,
        handleUpdateReview
    );
    yield takeEvery(
        ShoppingActionTypes.DELETE_REVIEW_REQUEST,
        handleDeleteReview
    );
}
